import React from 'react'

import * as S from './styles'

import { FormLabel, TooltipWithIcon } from '..'

import type { FormItemProps } from './types'

export const FormItem: React.FC<React.PropsWithChildren<FormItemProps>> = ({
  label,
  error,
  children,
  hint,
  tooltip,
  hidden,
  dataCy,
  'data-testid': dataTestId,
  isFullWidth = true,
  shouldKeepLabelSpacing,
  htmlFor,
}) => (
  <S.FormItem
    $hidden={hidden}
    data-cy={dataCy}
    data-testid={dataTestId}
    $isFullWidth={isFullWidth}
  >
    {(label || shouldKeepLabelSpacing) && (
      <FormLabel htmlFor={htmlFor}>
        {label}
        {tooltip && <TooltipWithIcon content={tooltip} />}
      </FormLabel>
    )}
    {children}
    {error?.message && <S.ErrorMessage>{error.message}</S.ErrorMessage>}
    {hint && <S.HintMessage>{hint}</S.HintMessage>}
  </S.FormItem>
)
